export default "__VITE_ASSET__CQ46Lpqg__"